import { Component, OnInit } from '@angular/core';
import { GenericService } from 'src/app/services/generic.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  header_logo_name = environment.header_logo_name
  header_logo = environment.header_logo

  menuToggle = false
  notificationType: any = "TICKET_NOTES"
  notificationReadStatus: any = false
  notificationReadToggle: any = "unread"
  notificationBlockToggle: any = false

  notificationData: any = []
  notificationDataCount: any = 0
  isLoading: any = false

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  userId: any

  constructor(private generic_service: GenericService) {
    this.generic_service.menuToggle.subscribe((value) => {
      this.menuToggle = Boolean(value)
    });

    this.generic_service.notification.subscribe((value) => {

      this.getByToUserId()
      // this.getNotificationByNotificationTypeAndNotificationReadStatus(this.notificationType,this.notificationReadStatus)
    });
  }

  ngOnInit(): void {
    this.userId = sessionStorage.getItem('userId')

    // this.getNotificationByNotificationTypeAndNotificationReadStatus(this.notificationType,this.notificationReadStatus)

    let json = JSON.parse('{"text":"Hello 31","ticketId":658}')

    this.getByToUserId()
  }

  logout() {
    sessionStorage.clear()
    window.location.href = "/login"
  }

  toggleMenu() {
    let menuClose = this.menuToggle;
    this.generic_service.menuToggle.next(!menuClose);
  }

  notificationShowOrHideToggle() {
    this.notificationBlockToggle = !this.notificationBlockToggle
  }

  getByToUserId() {
    this.isLoading = true
    this.generic_service.getByToUserId(this.userId, this.notificationReadStatus, this.pageNumber, this.recordsPerPage).subscribe(
      (response: any) => {
        console.log("getByToUserId", response)


        // for (let list of response.response.notificationList) {
        //   let json = JSON.parse(list.message)
        //   list.text = json.text
        //   list.ticketId = json.ticketId
        //   this.notificationData.push(list)
        // }

        this.notificationData = response.response.notificationList

        this.notificationDataCount = response.response.totalRecords
        this.totalRecords = response.response.totalRecords


        if (this.notificationReadToggle == "read") {
          this.notificationDataCount = 0
        } else {
          this.notificationDataCount = response.response.totalRecords
        }


        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  // getNotificationByNotificationTypeAndNotificationReadStatusAndToUserId(notificationType: any, notificationReadStatus: any, userId: any, pageNumber: any, recordsPerPage: any) {
  //   this.isLoading = true
  //   this.notificationData = []
  //   this.generic_service.getNotificationByNotificationTypeAndNotificationReadStatusAndToUserId(notificationType, notificationReadStatus, userId, pageNumber, recordsPerPage).subscribe(
  //     (response: any) => {
  //       console.log("dfghjk", response)
  //       // for(let list of response.response.notificationList){
  //       //   let json = JSON.parse('{"text":"Hello 31","ticketId":658}')
  //       //   console.log(json)
  //       // }

  //       for (let list of response.response.notificationList) {
  //         let json = JSON.parse(list.message)
  //         list.text = json.text
  //         list.ticketId = json.ticketId
  //         this.notificationData.push(list)
  //       }

  //       this.notificationDataCount = response.response.totalRecords
  //       this.totalRecords = response.response.totalRecords


  //       if (this.notificationReadToggle == "read") {
  //         this.notificationDataCount = 0
  //       } else {
  //         this.notificationDataCount = response.response.totalRecords
  //       }


  //       // if(notificationReadStatus != true){
  //       //   this.notificationDataCount = response.response.length
  //       // }
  //       this.isLoading = false

  //     },
  //     (error: any) => {
  //       console.log(error)
  //     }
  //   )
  // }

  getNotificationByNotificationTypeAndNotificationReadStatus(notificationType: any, notificationReadStatus: any) {
    this.isLoading = true

    this.generic_service.getNotificationByNotificationTypeAndNotificationReadStatus(notificationType, notificationReadStatus).subscribe(
      (response: any) => {
        this.notificationData = []
        this.notificationData = response.response
        if (notificationReadStatus != true) {
          this.notificationDataCount = response.response.length
        }
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  notificationReadUnReadToggle(status: any) {
    this.notificationReadStatus = Boolean(status)
    this.notificationData = []
    this.pageNumber = 0;
    this.totalRecords = 0;
    this.recordsPerPage = 10;


    if (this.notificationReadStatus) {
      this.notificationReadToggle = "read"

    } else {
      this.notificationReadToggle = "unread"

    }


    this.getByToUserId()
  }

  updateReadStatus(readStatus: any, notificationId: any) {
    this.generic_service.updateReadStatus(readStatus, notificationId).subscribe(
      (response: any) => {
        this.getByToUserId()
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  loadMore() {
    this.pageNumber = this.pageNumber + 1
    this.getByToUserId()
  }

  viewTicket(ticketId: any) {
    sessionStorage.setItem('view_ticketId', ticketId)

    window.location.href = "admin/ticketlist"
  }


}

